import * as React from "react";
import { omitBy } from "lodash-es";
import { casesActions } from "configs";
import {
  FormWatcherCallback,
  resolveNumber,
  resolveString,
  useCurrentCase,
  useDispatch,
  useParams
} from "duck";
import { useUpdateDentalChartingMutation } from "requests";
import { FormValues } from "./types";

export const useUpdateTreatments = (
  chartId: number | null,
  chartFakeId: string | null
) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();

  const [update] = useUpdateDentalChartingMutation({ ignoreResults: true });

  const shouldSync = useCurrentCase(data => data.shouldSync);

  return React.useCallback<FormWatcherCallback<FormValues>>(
    values => {
      const data = omitBy(
        {
          ...values,
          sutureMaterial: resolveString(values.sutureMaterial),
          restoratives: resolveString(values.restoratives),
          crCementation: resolveString(values.crCementation),
          obturation: resolveString(values.obturation),
          distalWorkingLength: resolveNumber(values.distalWorkingLength),
          mesialWorkingLength: resolveNumber(values.mesialWorkingLength),
          palatalWorkingLength: resolveNumber(values.palatalWorkingLength),
          distalMarFile: resolveNumber(values.distalMarFile),
          mesialMarFile: resolveNumber(values.mesialMarFile),
          palatalMarFile: resolveNumber(values.palatalMarFile)
        },
        value => value === undefined
      );

      if (chartId || chartFakeId) {
        dispatch(
          casesActions.updateDentalChart({
            _id: caseId,
            data: {
              ids: [chartId || chartFakeId],
              ...data
            } as any
          })
        );
      }

      if (chartId && shouldSync) {
        return update({ variables: { input: { _id: chartId, ...data } } });
      }
    },
    [shouldSync, chartFakeId, chartId]
  );
};
